import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { CardDescription, PaddedContainer, TagBase } from './styled';
import { DataTestAttributes } from '../../../constants/DataTestAttributes';
import CardLogo from '../../CardLogo';
import { ACCOUNT_TYPE, WalletMOP } from '../../../constants/PaymentTypes';
import useScreenBreakpoints, { ScreenSize } from '../../../hooks/useScreenBreakpoint';
import { colors } from '@chegg-ui/theme';
import { getString } from '../../../constants/Strings';
import { getPaymentFieldLabelText } from '../../PaymentForm/helpers';
import { PaymentFormDataFields } from '../../UserAddress/constants';
import { paymenFormSelector } from '../../../redux/ConfigState/ConfigState.selectors';
import { useAppSelector } from '../../../hooks/useAppSelector';
export var MopDisplayContent = function MopDisplayContent(props) {
  var _props$mop = props.mop,
    type = _props$mop.type,
    accountType = _props$mop.accountType,
    last4 = _props$mop.last4,
    month = _props$mop.month,
    year = _props$mop.year,
    isBackup = _props$mop.isBackup,
    isPrimary = _props$mop.isPrimary,
    ariaDescribedById = props.ariaDescribedById,
    isCheckoutPage = props.isCheckoutPage;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    expDate = _useState2[0],
    setExpDate = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobile = _useState4[0],
    setIsMobile = _useState4[1];
  var screenSize = useScreenBreakpoints();
  var paymentForm = useAppSelector(paymenFormSelector);
  useEffect(function () {
    setIsMobile(screenSize === ScreenSize.PHONE || screenSize === ScreenSize.TABLET);
  }, [screenSize]);
  var expWithDate = function expWithDate(month, year) {
    var expirationWithDate = getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.EXP_WITH_DATE);
    if (expirationWithDate === '') {
      expirationWithDate = getString('APP.FORM.EXPWITHDATE');
    }
    expirationWithDate = expirationWithDate.replace('${month}', month).replace('${year}', year.substring(2));
    return WalletMOP.includes(accountType) ? '' : expirationWithDate;
  };
  var cardEndingContentFul = function cardEndingContentFul(last4) {
    var cardEndingTemplete = getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.CARD_ENDING_IN);
    if (cardEndingTemplete === '') {
      cardEndingTemplete = getString("APP.FORM.CARD_ENDING_IN");
    }
    return cardEndingTemplete.replace('${last4}', last4);
  };
  useEffect(function () {
    if (month && year) {
      setExpDate(expWithDate(month, year));
    }
  }, [month, year]);
  var creditCardTextDataTest = "".concat(DataTestAttributes.EXISTING_CARD_DESCRIPTION, "-").concat(last4);
  var creditCardText = isMobile ? '' : cardEndingContentFul(last4);
  var tagBackgroundColor = isPrimary ? colors.orange100 : isBackup ? colors.skyXlight : '';
  var cardHolderDescription = function cardHolderDescription() {
    var accountTypeDescriptions = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ACCOUNT_TYPE.APPLE_PAY, 'Apple Pay'), ACCOUNT_TYPE.GOOGLE_PAY, 'Google Pay'), ACCOUNT_TYPE.PAYPAL_TOKEN, 'PayPal'), ACCOUNT_TYPE.VENMO, 'Venmo'), ACCOUNT_TYPE.CREDIT_CARD, creditCardText), ACCOUNT_TYPE.BALANCE, creditCardText), ACCOUNT_TYPE.GIFT_CODE, creditCardText), ACCOUNT_TYPE.UPI, creditCardText), ACCOUNT_TYPE.PLACEHOLDER, creditCardText);
    return accountTypeDescriptions[accountType] || creditCardText;
  };
  var getCardType = function getCardType() {
    if (accountType == ACCOUNT_TYPE.GOOGLE_PAY) {
      return accountType;
    }
    return type || accountType;
  };
  var cardInfo = cardHolderDescription();
  return /*#__PURE__*/React.createElement(PaddedContainer, null, /*#__PURE__*/React.createElement(CardLogo, {
    cardType: getCardType(),
    valid: true,
    dataTest: 'card-logo',
    id: ariaDescribedById && "logo:".concat(ariaDescribedById),
    isMopContainer: true
  }), /*#__PURE__*/React.createElement(CardDescription, {
    id: ariaDescribedById && "description:".concat(ariaDescribedById),
    title: cardInfo,
    "data-test": "".concat(last4 ? creditCardTextDataTest : DataTestAttributes.EXISTING_MOP_TEXT)
  }, /*#__PURE__*/React.createElement("span", {
    className: "card-info"
  }, cardInfo), expDate && /*#__PURE__*/React.createElement("span", {
    className: "exp-date"
  }, expDate)), (isPrimary || isBackup) && /*#__PURE__*/React.createElement(TagBase, {
    backgroundColor: tagBackgroundColor,
    isCheckoutPage: isCheckoutPage,
    "data-test": "".concat(isPrimary ? 'default' : isBackup ? 'backup' : '', "-tag")
  }, isPrimary ? getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.PRIMARY_PAYMENT_METHOD) || getString('APP.MOPONFILE.DEFAULTLABEL') : isBackup ? getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.BACKUP_PAYMENT_METHOD) || getString('APP.MOPONFILE.BACKUPLABEL') : ''));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Recurly/MopListView/MopDisplayContent.js
// module id = 4641
// module chunks = 11